import { getApiUrl, getRestUrl } from '..';
import { PROVIDERS } from '../../constants';
import Instance from '../https';

export const getCountriesList = (controller: string, action: string) => {
   const url = `?IncludeStates=true`;
   return Instance.get(`${getApiUrl(controller, action)}${url}`);
};

export const getFacilitiesList = (controller: string, action: string) => {
   return Instance.get(`${getRestUrl(controller, action)}`);
};

export const getSpecialtiesList = (controller: string, action: string) => {
   return Instance.get(`${getRestUrl(controller, action)}`);
};

export const getGroupsList = (controller: string, action: string) => {
   return Instance.get(`${getRestUrl(controller, action)}/query`);
};

export const getRolesList = (controller: string, action: string) => {
   return Instance.get(`${getRestUrl(controller, action)}/query`);
};

export const getIdentityProviders = (controller: string, action: string) => {
   const url = `?ProviderType=1`;
   return Instance.get(`${getApiUrl(controller, action)}${url}`);
};

export const getProviders = (controller: string, action: string) => {
   return Instance.get(`${getApiUrl(controller, action)}${PROVIDERS}`);
};

export const getUsersList = (controller: string, action: string) => {
   const url = '/query';
   return Instance.get(`${getRestUrl(controller, action)}${url}`);
};

export const getUsersById = (controller: string, action: string, id: string) => {
   return Instance.get(`${getApiUrl(controller, action)}${id}`);
};

export const getUsersTableList = (
   controller: string,
   action: string,
   PageNumber: number,
   PageSize = 10,
   searchData: Record<string, any>,
) => {
   let url = `?PageNumber=${PageNumber}&PageSize=${PageSize}`;

   if (searchData && searchData.Status && searchData.Status !== null && searchData.Status !== undefined) {
      url += `&Status=${searchData.Status}`;
   }
   if (searchData && searchData.DateFrom && searchData.DateFrom !== null && searchData.DateFrom !== undefined) {
      url += `&DateFrom=${searchData.DateFrom}`;
   }

   if (searchData && searchData.DateTo && searchData.DateTo !== null && searchData.DateTo !== undefined) {
      url += `&DateTo=${searchData.DateTo}`;
   }
   return Instance.get(`${getApiUrl(controller, action)}${url}`);
};

export const createUser = (controller: string, action: string, values: any) => {
   return Instance.post(`${getRestUrl(controller, action)}`, values);
};

export const resetTempPassword = (controller: string, action: string, id: string, section: string, values: any) => {
   const url = `/${id}/${section}`;
   return Instance.post(`${getRestUrl(controller, action)}${url}`, values);
};

export const changeUserPassword = (controller: string, action: string, section: string, values: any) => {
   return Instance.put(`${getApiUrl(controller, action)}${section}`, values);
};

export const patchUserInfo = (controller: string, action: string, section: string, values: any, param?: string) => {
   const url = param ? `/${param}/${section}` : `/${section}`;
   return Instance.patch(`${getRestUrl(controller, action)}${url}`, values);
};

export const resetFirstTimer = (controller: string, action: string, section: string) => {
   return Instance.put(`${getApiUrl(controller, action)}${section}`);
};
